import * as Actions from './types';

const CommonActions = {
  setSnackbarMessage: message => dispatch => dispatch({ type: Actions.UPDATE_SNACKBAR_MESSAGE, message }),
};

export default CommonActions;